import { findAncestor } from '../../utils/dom'

const getParentGlider = (el) => {
  const parentGlider = findAncestor(el, 'glideId');
  if (!parentGlider) {
    console.info('Can\'t find glider el')
    return false
  }
  const glideId = parentGlider.dataset.glideId;
  if (!glideId) {
    console.info('Glider has no glideId')
    return false
  }
  return window.blubolt.glides[glideId]
 
}

export default getParentGlider